import React from 'react';
import * as Utils from 'utils';

export default function CartOptions({
  options,
  optionsTotal,
  optionsPages,
}) {
  var pagesTotalCount = optionsPages.reduce((accumulator, currentValue) => accumulator + currentValue.totalQuantity, 0);
  var pagesTotalWithoutStaticCount = optionsPages.reduce((accumulator, currentValue) => {
    return currentValue.title !== 'Static' ? accumulator + currentValue.totalQuantity : accumulator;
  }, 0);

  return (
    <>
      {options.length > 0 &&
        <div className="app-cart-options">
          <div className="app-cart-option-list">
            {options.map((option, optionIndex) => {
              return (
                <div className="app-cart-option-item" key={optionIndex}>
                  <div className="app-cart-line">
                    <div className="app-cart-line-left">
                      <span className="app-cart-text-parameter-light">{Utils.replacer(option, 'priceLabel')}</span>
                    </div>
                    <div className="app-cart-line-right">
                      { option.isForEveryPage ? (
                          (option.label === 'Cycled animation' || option.label === 'Animation reload') ?(
                              <>
                                <span className="app-cart-text-value-light">{pagesTotalWithoutStaticCount} &#215; {Utils.replacer(option, 'priceValueText')} = </span>
                                <span className="app-cart-text-value">${pagesTotalWithoutStaticCount * option.priceValue}</span>
                              </>
                          ):(
                              <>
                                <span className="app-cart-text-value-light">{pagesTotalCount} &#215; {Utils.replacer(option, 'priceValueText')} = </span>
                                <span className="app-cart-text-value">${pagesTotalCount * option.priceValue}</span>
                              </>
                          )
                      ):(
                          <>
                            <span className="app-cart-text-value">{Utils.replacer(option, 'priceValueText')}</span>
                          </>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          {optionsTotal > 0 &&
            <div className="app-cart-total">
              <div className="app-cart-line">
                <div className="app-cart-line-left">
                  <span className="app-cart-text-parameter">Options total</span>
                </div>
                <div className="app-cart-line-right">
                  <span className="app-cart-text-value">${optionsTotal}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </>
  )
}
